import React from "react";
import { Phone, ClipboardCheck, MapPin, Star } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, HERO_IMG, LOGO } from "../../lib/site";

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative pt-20">
      <div className="absolute inset-0">
        <img src={HERO_IMG} alt="Local handyman working on a home in North Georgia" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#0A1E3F]/85" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="max-w-3xl animate-fade-up">
          <img
            src={LOGO}
            alt="Journey's Handyman Services logo"
            data-testid="hero-logo"
            className="h-44 sm:h-56 w-auto object-contain bg-white rounded-2xl p-4 shadow-hard-red mb-8"
          />
          <div className="inline-flex items-center gap-2 bg-[#C8102E] text-white font-heading font-bold uppercase tracking-[0.2em] text-xs sm:text-sm px-4 py-2 mb-6">
            <MapPin className="h-4 w-4" strokeWidth={3} />
            Blairsville, GA 30512 · North Georgia
          </div>

          <h1 className="font-heading text-5xl sm:text-6xl md:text-7xl font-black uppercase tracking-tight leading-[0.95] text-white">
            Blairsville Handyman Services & Home <span className="text-[#C8102E]">Restoration</span>
          </h1>

          <p className="mt-6 text-lg sm:text-xl text-white/85 font-medium max-w-2xl leading-relaxed">
            Your trusted local handyman for home repairs, remodels and 24/7 emergency
            restoration — serving Blairsville, Young Harris, Hiawassee, Blue Ridge and
            Murphy, NC. One call does it all.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a
              href={`tel:${PHONE_TEL}`}
              data-testid="hero-call-button"
              className="inline-flex items-center justify-center gap-3 bg-[#C8102E] hover:bg-[#9E0C24] text-white font-heading font-bold uppercase tracking-wide text-lg px-8 py-4 shadow-hard-sm hover:translate-x-1 hover:translate-y-1 hover:shadow-none transition-all"
            >
              <Phone className="h-6 w-6" strokeWidth={2.5} />
              Call {PHONE_DISPLAY}
            </a>
            <a
              href="#quote"
              data-testid="hero-quote-button"
              className="inline-flex items-center justify-center gap-3 bg-white hover:bg-[#F6F5F0] text-[#0E2A56] font-heading font-bold uppercase tracking-wide text-lg px-8 py-4 transition-colors"
            >
              <ClipboardCheck className="h-6 w-6" strokeWidth={2.5} />
              Get a Free Quote
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 text-white/90 font-semibold">
            <span className="flex items-center gap-2">
              <span className="flex text-[#F6B100]">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 fill-current" />
                ))}
              </span>
              Trusted by North GA homeowners
            </span>
            <span className="hidden sm:inline text-white/40">|</span>
            <span>Free Estimates</span>
          </div>
        </div>
      </div>
    </section>
  );
};
